import { IAuthenticationContext, ESentEmailType, EEventType } from '@cian/authentication-widget';
import { openAuthenticationPopup } from '../../services/authentication';
import { EAlertType } from '../../AuthenticationPopup';

export interface IWaitForLoginPopupFactoryParameters {
  authenticationContext: IAuthenticationContext;
  defaultCallback(): void;
}

export const waitForLoginPopupFactory = ({
  authenticationContext,
  defaultCallback,
}: IWaitForLoginPopupFactoryParameters) => {
  return (alert?: EAlertType, onAuthenticationSucceed?: () => void) => {
    let isRegistered = false;

    const handleSocialAuthenticateSucceed = ({ isNewUser }: { isNewUser: boolean }) => {
      if (!isNewUser) {
        handleAuthenticationSucceed();
      } else {
        isRegistered = true;
      }
    };

    function handleAuthenticationSucceed() {
      if (onAuthenticationSucceed) {
        onAuthenticationSucceed();
      } else {
        defaultCallback();
      }

      authenticationContext.off(EEventType.AuthenticateSucceed, handleAuthenticationSucceed);
      authenticationContext.off(EEventType.SocialAuthenticateSucceed, handleSocialAuthenticateSucceed);
      authenticationContext.off(EEventType.EmailSentClosed, handleEmailSentClosed);
      authenticationContext.off(EEventType.RegisterSucceed, handleRegisterSucceed);
    }

    function handleRegisterSucceed({ isSms }: { isSms: boolean }) {
      isRegistered = true;
      if (isSms) {
        handleAuthenticationSucceed();
      }
    }

    function handleEmailSentClosed({ type }: { type: ESentEmailType }) {
      if (type === ESentEmailType.Registration) {
        handleAuthenticationSucceed();
      }
    }

    authenticationContext.on(EEventType.AuthenticateSucceed, handleAuthenticationSucceed);
    authenticationContext.on(EEventType.SocialAuthenticateSucceed, handleSocialAuthenticateSucceed);
    authenticationContext.on(EEventType.EmailSentClosed, handleEmailSentClosed);
    authenticationContext.on(EEventType.RegisterSucceed, handleRegisterSucceed);

    openAuthenticationPopup({
      context: authenticationContext,
      alert,
      onClose: () => {
        if (isRegistered) {
          return handleAuthenticationSucceed();
        }

        authenticationContext.off(EEventType.AuthenticateSucceed, handleAuthenticationSucceed);
        authenticationContext.off(EEventType.SocialAuthenticateSucceed, handleSocialAuthenticateSucceed);
        authenticationContext.off(EEventType.EmailSentClosed, handleEmailSentClosed);
        authenticationContext.off(EEventType.RegisterSucceed, handleRegisterSucceed);
      },
    });
  };
};
